<form #paymentForm="ngForm" class="payment_form" id="paymentForm" novalidate>
  <div class="form_item_wrapper">
    <label class="form_item_label" for="nameOnCard">{{ getLabel('nameCard')}}</label>
      <input
        data-qa="card-name"
        id="nameOnCard"
        name="nameOnCard"
        #nameOnCard="ngModel"
        [(ngModel)]="cardName"
        type="text"
        required
        pattern="{{ nameOnCardPattern }}"
        class="item_input"
      />
  </div>
  <div class="form_item_wrapper hidden">
    <label class="form_item_label" for="typeOfCard">{{ getLabel('cardType')}}</label><br>
    <div class="form_item_elements">
      <select
        data-qa="card-type"
        id="typeOfCard"
        name="typeOfCard"
        #typeOfCard="ngModel"
        [(ngModel)]="cardType"
        required
        class="item_select item_cartType"
        (change)="forceTypeNumberValidation()"
      >
        <option *ngFor="let brand of cardBrands" value="{{ brand.type }}">{{ brand.name}}</option>
      </select>
    </div>
  </div>

  <div class="form_item_wrapper">
    <label class="form_item_label" for="cardNumber">{{ getLabel('cardNumber')}}</label>
    <input fixScrollOnMobileiOS id="cardNumber" name="number" #number="ngModel"
    [(ngModel)]="cardDetails.card" required data-stripe="number" data-storage="false"
    type="tel" class="item_input" (paste)="validateMask($event);getCreditCardType($event)"
    (blur)="validateMask($event);getCreditCardType($event)"
    (keyup)="validateMask($event);getCreditCardType($event)"
    (change)="getCreditCardType($event);validateMask($event)" />
  </div>

  <article class="exp-cvv-wrapper">
    <div class="form_item_wrapper">
      <label class="form_item_label" for="expCard">{{ getLabel('expirationDate') }}</label>
      <input data-qa="card-exp-month" id="expMonth" name="expmonth" #expmonth="ngModel"[(ngModel)]="cardDetails.expmonth" class="hideInputCvv" (input)="autoFillEvent($event,1)"
      (nativeAutofill)="autoFillEvent($event,1)" (keydown)="clearExpirationDate($event)" tabindex="-1">
      <input data-qa="card-exp-year" id="expYear" name="expyear" [(ngModel)]="cardDetails.expyear" #expyear="ngModel" class="hideInputCvv" (input)="autoFillEvent($event,2)"
        (nativeAutofill)="autoFillEvent($event,2)" (keydown)="clearExpirationDate($event)" tabindex="-1">
      <div class="form_item_elements">
        <input fixScrollOnMobileiOS type="tel" (keydown)="clearExpirationDate($event)"
          (change)="validateExpCard($event)" (input)="validateExpCard($event)"
          id="expCard" placeholder="MM/YY" name="expCard" #expCard="ngModel"
          [(ngModel)]="cardDetails.expCard" required data-storage="false" class="item_input item_month"
          (nativeAutofill)="handleDateInput($event)" />
      </div>
    </div>

    <div class="form_item_wrapper form_item_code">
      <label class="form_item_label" for="cvcCode">{{ getLabel('cvvTC') }}</label>
        <input placeholder="CVV" fixScrollOnMobileiOS id="cvcCode" name="code" #code="ngModel"
          [(ngModel)]="cardDetails.cardccv" required autocomplete="off" [minlength]="card.codeLength"
          [maxlength]="card.codeLength" data-stripe="cvc" data-storage="false" (input)="formatInputData(FIELDS.CODE)"
          type="tel" class="item_input item_code" />
    </div>
  </article>
  <a class="new_item_link"
    (click)="openWhatIsthis()">What is this?</a>
</form>